import React from 'react';
import { Table } from 'reactstrap';

export const TsuWarnStatusModal = {
  title: 'Warning Status',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>-1 to 4</b>
      </div>
      <br />
      Warning Status of the Tsunami:
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">-1</th>
            <td>Status unknown</td>
          </tr>
          <tr>
            <th scope="row">0</th>
            <td>no warning issued</td>
          </tr>
          <tr>
            <th scope="row">1</th>
            <td>PTW - Pacific-wide Tsunami Warning issued by PTWC</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>RTW - Regional Tsunami Warning issued by PTWC for areas having no TWS</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>LTW - Local Tsunami Warning issued by regional or national TWC</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>TIB - Tsunami Information or Attention Bulletin issued by any agency</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
};
